import warelyLogo from "../../assets/svgs/warley.svg" 
import "./notFound.css";

const NotFound = () => {

  return (
    <div className="notfound-container">
      <img src={warelyLogo} alt="Warely Logo" className="notfound-logo" />
      
    
      <h1>Something went wrong</h1>
   
      <p>Please try again later.</p>
      
    </div>
  );
};

export default NotFound;